export const ROLES = {
  ROLE_CUSTOMER: 'ROLE_CUSTOMER',
  ROLE_ADMIN: 'ROLE_ADMIN',
  ROLE_AGENT: 'ROLE_AGENT',
  ROLE_CALL_AGENT: "ROLE_CALL_AGENT",
  ROLE_SUB_AGENT: "ROLE_SUB_AGENT"
} as const;